import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FooterSecondaryButton } from 'pageComponents/_common/HubSpotBlogSubscription'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import { useAirlineFetch } from 'setup/REST'
import styled from 'styled-components'

const ImproveButton = styled.button`
	border: 0;
	font-size: 10pt;
	font-style: italic;
	padding: 3px;
	margin: 0px;
	opacity: 70%;
	border-radius: 4px 0 4px 4px;
	background-color: #FFF;
`
//The idea of the hanger div is to construct a full-width but zero-height div
//that can be relatively positioned, then stuff an absolutely positioned div
// inside that, with a particular width
const FeedbackHangerDiv = styled.div`
	position: absolute;
	right: 0; 
	top: 0;
	width: 160px;
`

const FeedbackFormContainer = styled.div`
	background-color: ${props => props.theme.backgroundColor};
	width: 350px;
	display: flex;
	height: 200px;
	position: absolute;
	right: 0; 
	top: 0;
	flex-direction: column;
	border-radius: 4px 0 4px 4px;
	border: 1px solid ${props => props.theme.divisionColorBlendDarker};
	* {
		padding: 0 4px 0 4px;
		
	}
	svg {
		color: black;
		padding: 0 4px 0 0;
	}
	textarea, input[type=text], button {
		font-size: 10pt;
		margin: 2px 4px 2px 4px;
		border: 1px solid ${props => props.theme.divisionColorBlendDarker};
	}
	button {
		align-self: center;
		height: 32px;
		width: 52px;
		border: none;
	}
	#thanks {
		margin: auto auto;
	}
`
const FeedbackFormHeader = styled.div`
	display: flex;
	justify-content: space-between;
	background-color: ${props => props.theme.divisionColorBlendDarker};
`

export default function FeedbackForm() {
	const [openFeedbackModal, setOpenFeedbackModal] = useState(false);
	const [showThankyou, setShowThankyou] = useState(false);
	const [feedbackComment, setFeedbackComment] = useState('');
	const [emailInput, setEmailInput] = useState('');
	const loc = useLocation();
	const { airlinePost } = useAirlineFetch();

	//If the user navigates, close the feedback form. 
	useEffect(() => {
		setOpenFeedbackModal(false);
	},[loc]);

	function submitFeedback() {
		const data = { 
			ResponseEmail: emailInput,
			Comment: feedbackComment,
			Url: loc.pathname
		};
		airlinePost(`${process.env.REACT_APP_API_URL}/api/Feedback/airlineweb`, data)
			.then(() =>{
				setFeedbackComment("");
				setOpenFeedbackModal(false);
			}).then(() => {
				setShowThankyou(true);
				setTimeout(() => setShowThankyou(false), 4000);
			});
	}

	return (<FeedbackHangerDiv>
				<ImproveButton onClick={()=>setOpenFeedbackModal(true)}>[+] How can we improve?</ImproveButton>
				{showThankyou && <FeedbackHangerDiv>
					<FeedbackFormContainer>
						<FeedbackFormHeader>
							<span>How can we improve?</span>
							<FontAwesomeIcon style={{ cursor: 'pointer' }} onClick={()=>{ setShowThankyou(false); setOpenFeedbackModal(false);}} icon='times' size='lg' color='lightgrey' />
						</FeedbackFormHeader>
						<span id="thanks">Thanks for taking the time to leave a comment!</span>
					</FeedbackFormContainer>
				</FeedbackHangerDiv>}
				{openFeedbackModal && <FeedbackHangerDiv>
					<FeedbackFormContainer>
						<FeedbackFormHeader>
							<span>How can we improve?</span>
							<FontAwesomeIcon style={{ cursor: 'pointer' }} onClick={()=>setOpenFeedbackModal(false)} icon='times' size='lg' color='lightgrey' />
						</FeedbackFormHeader>
						<textarea maxLength={2000} placeholder='Comments (please use Contact Us for sales help)' value={feedbackComment} onChange={(e) => setFeedbackComment(e.target.value)} rows={4} />
						<span>Your email (optional)</span>
						<input type="text" value={emailInput} onChange={(e) => setEmailInput(e.target.value)} maxLength={255} />
						<FooterSecondaryButton onClick={submitFeedback}>Send</FooterSecondaryButton>
					</FeedbackFormContainer>
				</FeedbackHangerDiv>}
			</FeedbackHangerDiv>);
}
